import React from 'react'
import { I18n } from '@front/volcanion/'
import { TimeUtils } from '@front/volcanion/utils'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'
import { TextComponent, TextField } from '@front/squirtle'

const Row1 = (props) => {
  return (
    <Grid container spacing={1} size={12}>
      <Grid size={12}>
        <TextField
          name={'title'}
          label={I18n.t('title.label', { count: 1 })}
          disabled
        />
      </Grid>
    </Grid>
  );
}

const Row2 = ({ order }) =>
  <Grid container spacing={1} size={12}>
    <Grid>
      <TextComponent
        label={I18n.t('commercialpackage.label', { count: 1 })}
        value={order?.commercial_package?.name}
        disabled
      />
    </Grid>
    <Grid>
      <TextComponent
        label={I18n.t('date.label.full')}
        value={TimeUtils.formatDateBackToFront(order?.requestedAt)}
        disabled
      />
    </Grid>
    <Grid>
      <TextComponent
        label={I18n.t('company.label', { count: 1 })}
        value={order?.service?.contract?.company?.name}
        disabled
      />
    </Grid>
    <Grid>
      <TextComponent
        label={I18n.t('address.start')}
        value={order?.source?.postal_code}
        disabled
      />
    </Grid>
    <Grid>
      <TextComponent
        label={I18n.t('address.destination')}
        value={order?.destination?.postal_code}
        disabled
      />
    </Grid>
    <Grid>
      <TextComponent
        label={I18n.t('payment.label', { count: 1 })}
        value={order?.payment_type?.name_translated}
        disabled
      />
    </Grid>
  </Grid>


const JobInfoSection = (props) => <>
  <StepLabel>
    <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 'h6.fontSize', color: 'text.title' }}>
      <Typography variant='h5'>{I18n.t('message.label', { count: 1 })}</Typography>
    </Box>
  </StepLabel>
  <StepContent >
    <Box sx={{ boxShadow: 6, borderRadius: 1, p: 2 }}>
      <Row1 {...props} />
      <Row2 {...props} />
    </Box>
  </StepContent>
</>

export default JobInfoSection
